import React, { FC, ReactNode } from 'react';

import { EnvItem } from './env-item';

export interface IEnvListProps {
  data: {
    [key: string]: any;
  };
  renderItem?(key: string, value: any, index: number): ReactNode;
}
export const EnvList: FC<React.PropsWithChildren<IEnvListProps>> = ({
  data,
  renderItem = (key, value) => <EnvItem key={key} envKey={key} value={value} />,
}) => <>{Object.entries(data).map(([key, value], index) => renderItem(key, value, index))}</>;
